export default function() {
  $(document).ready(function() {
    window.thinkwell.lib.inject('/pages/registration', '/accounts/classroom_registration', '.page-content');
  });
}
